import { useQuery } from "@tanstack/react-query";
import { axiosSecured } from "../../api/axiosClient";
import {
  FETCH_ENTITLED_MODULES,
  FETCH_PERMISSIONS,
} from "../permissions/api/permissions-api";
import { RETRY_DELAY } from "../../utils/constants";

const usePermissionsApi = () => {
  const {
    data: allPermissions = [],
    isLoading: isPermissionsLoading,
    refetch: fetchPermissions,
    isError: isPermissionError,
  } = useQuery({
    queryKey: ["fetchPermissions"],
    queryFn: () =>
      axiosSecured
        .get(FETCH_PERMISSIONS)
        .then((res) => res.data.data)
        .catch(console.error),
    retry: 3,
    retryDelay: RETRY_DELAY,
    enabled: false,
  });

  const {
    data: allEntitledModules = [],
    isLoading: isFetchingEntitledModules,
    refetch: fetchEntitledModules,
    isError: isModuleFetchError,
  } = useQuery({
    queryKey: ["fetchEntitledModules"],
    queryFn: () =>
      axiosSecured
        .get(FETCH_ENTITLED_MODULES)
        .then((res) => res.data.data)
        .catch(console.error),
    retry: 3,
    retryDelay: RETRY_DELAY,
    enabled: false,
  });

  return {
    getAllPermissionsApi: {
      get: fetchPermissions,
      isLoading: isPermissionsLoading,
      data: allPermissions,
      error: isPermissionError,
    },
    getAllEntitledModulesApi: {
      get: fetchEntitledModules,
      isLoading: isFetchingEntitledModules,
      data: allEntitledModules,
      error: isModuleFetchError,
    },
  };
};

export default usePermissionsApi;
